import { Globe } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useT } from "@/i18n";
import { LOCALES, LOCALE_META, pathForLocale, type Locale } from "@/i18n/locales";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, locale } = useT();

  function switchTo(next: Locale) {
    if (typeof window === "undefined" || next === locale) return;
    const target = pathForLocale(window.location.pathname, next);
    document.cookie = `behot_locale=${next}; path=/; max-age=31536000; samesite=lax`;
    // Full navigation: the locale lives in the router basepath.
    window.location.assign(`${target}${window.location.search}${window.location.hash}`);
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={className}
          aria-label={t("lang.change")}
          title={t("lang.select")}
        >
          <Globe className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-44">
        {LOCALES.map((code) => (
          <DropdownMenuItem
            key={code}
            onSelect={() => switchTo(code)}
            className={code === locale ? "font-semibold text-primary" : undefined}
          >
            {LOCALE_META[code].label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
